// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"f599cc85","730":"ae8835af"}[chunkId] + ".chunk.js";
};